export enum Specialty {
  ADDICTION_MEDICINE = "Addiction Medicine",
  ALLERGY_ASTHMA = "Allergy & Asthma",
  ALLERGY_IMMUNOLOGY = "Allergy Immunology",
  APPLIED_BEHAVIORAL_ANALYSIS_THERAPY = "Applied Behavioral Analysis Therapy",
  ART_THERAPY = "Art Therapy",
  AUDIOLOGY = "Audiology",
  BEHAVIORAL_HEALTH = "Behavioral Health",
  BURN = "Burn",
  CARDIOLOGY = "Cardiology",
  CARDIOTHORACIC = "Cardiothoracic",
  CARDIOVASCULAR = "Cardiovascular",
  CARE_PARTNER = "Care Partner",
  CHILD_LIFE = "Child Life",
  CHIROPRACTOR = "Chiropractor",
  CHRYSALIS = "Chrysalis",
  COLORECTAL = "Colorectal",
  CRANIOFACIAL = "Craniofacial",
  CV_SURGERY = "CV Surgery",
  CV_SURGERY_OFFICE_NOTE = "CV Surgery Office Note",
  DENTAL_SLEEP_MEDICINE = "Dental Sleep Medicine",
  DENTISTRY = "Dentistry",
  DERMATOLOGY = "Dermatology",
  EARLY_INTERVENTION = "Early Childhood Intervention",
  ELECTROPHYSIOLOGY = "Electrophysiology",
  ELECTROPHYSIOLOGY_CONSULT = "Electrophysiology Consult",
  ELECTROPHYSIOLOGY_PROCEDURE = "Electrophysiology Procedure",
  ENDOCRINOLOGY = "Endocrinology",
  ENT = "ENT",
  FEEDING_TUBE_THERAPY = "Feeding Tube Therapy",
  GASTROENTEROLOGY = "Gastroenterology",
  GENERAL_SURGERY = "General Surgery",
  GENETICS = "Genetics",
  GI = "GI",
  GYN = "GYN",
  HEMATOLOGY_ONCOLOGY = "Hematology/Oncology",
  HEM_ONC = "Hem-Onc",
  HOME_HEALTH = "Home Health",
  HOME_INFUSION = "Home Infusion",
  IEP = "IEP",
  IMMUNOLOGY = "Immunology",
  INFECTIOUS_DISEASE = "Infectious Disease",
  INFUSION = "Infusion",
  INTERNAL_MEDICINE = "Internal Medicine",
  INTERVENTIONAL_RADIOLOGY = "Interventional Radiology",
  LACTATION = "Lactation",
  MUSIC_THERAPY = "Music Therapy",
  NEONATAL = "Neonatal",
  NEPHROLOGY = "Nephrology",
  NEUROLOGY = "Neurology",
  NEUROPSYCHOLOGY = "Neuropsychology",
  NEUROSURGERY = "Neurosurgery",
  NUTRITION = "Nutrition",
  OB_GYN = "OB/GYN",
  OBGYN = "OBGYN",
  OCCUPATIONAL_THERAPY = "Occupational Therapy",
  ONCOLOGY = "Oncology",
  OPHTHALMOLOGY = "Ophthalmology",
  ORTHO = "Ortho",
  ORTHOPEDICS = "Orthopedics",
  OTHER = "Other",
  PAIN_MANAGEMENT = "Pain Management",
  PALLIATIVE_CARE = "Palliative Care",
  PHYSICAL_MEDICINE_AND_REHABILITATION = "Physical Medicine and Rehabilitation",
  PHYSICAL_THERAPY = "Physical Therapy",
  PLASTIC_SURGERY = "Plastic Surgery",
  PODIATRY = "Podiatry",
  PRIMARY_CARE = "Primary Care",
  PSYCHIATRY_MENTAL_HEALTH = "Psychiatry-Mental Health",
  PULMONOLOGY = "Pulmonology",
  RADIOLOGY = "Radiology",
  RESPIRATORY_THERAPY = "Respiratory Therapy",
  RHEUMATOLOGY = "Rheumatology",
  SLEEP_MEDICINE = "Sleep Medicine",
  SPEECH_THERAPY = "Speech Therapy",
  SURGERY = "Surgery",
  UNCLEAR = "Unclear",
  URGENT_CARE = "Urgent Care",
  UROGYNECOLOGY = "Urogynecology",
  UROLOGY = "Urology",
  VASCULAR = "Vascular",
  VASCULAR_SURGERY = "Vascular Surgery",
  VASCULAR_SURGERY_OFFICE_NOTE = "Vascular Surgery Office Note",
  VETERANS_AFFAIRS = "VA / Veterans Affairs",
  WEIGHT_MANAGEMENT = "Weight Management",
  WOUND_CARE = "Wound Care",
}
